export default __webpack_public_path__ + "static/media/background-portal-1.c2006cbd.svg";